import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'katex/dist/katex.min.css'; // fórmulas matemáticas da área de Simulados (RichTextEditor)
import reportWebVitals from './reportWebVitals';
import AppRouter from './AppRouter';
import { Buffer } from 'buffer'
import TypeBotStudent from './components/TypeBotStudent';

window.Buffer = window.Buffer ?? Buffer

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// check env var either with or without REACT_APP_ prefix
const showMaintenance =
  process.env.REACT_APP_SHOW_MANUTENCION_MESSAGE === 'true' ||
  process.env.SHOW_MANUTENCION_MESSAGE === 'true';

if (showMaintenance) {
  // render a standalone maintenance page and nothing else
  import('./pages/Maintenance').then(({ default: Maintenance }) => {
    root.render(
      <React.StrictMode>
        <Maintenance />
      </React.StrictMode>
    );
  });
} else {
  root.render(
    <React.StrictMode>
      <AppRouter />
      <TypeBotStudent />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
